// extracted by mini-css-extract-plugin
export default {"Footer_menu__wrapper":"FooterMenu_Footer_menu__wrapper__Ljfp3","Footer_menu":"FooterMenu_Footer_menu__okKtK"};